import { CheckIcon } from "lucide-react";
import { IoClose } from "react-icons/io5";
import styled from "styled-components";

export const ContactMeContainer = styled.div`
    position: fixed;
    z-index: 5000;
    left: 0;
    top: 0;
    width: 100%;
    min-height: -webkit-fill-available;
    overflow: auto;
    background-color: #3a3939e6;
    color: var(--color-coal);
    max-height: 100vh !important;
    overflow-y: scroll;
    p {
    margin-bottom: 0px;
    }
`;

export const ContactMeContent = styled.div`
    background-color: rgb(236 236 236);
    width: 99%;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
    padding: 0px 32px 32px 32px;
    margin-top: 12%;
    border-radius: 12px;
    @media (min-width: 700px) { 
        width: 500px;
    }
`;

export const ContactMeHeadline = styled.h1`
    font-size: 1.5rem;
    margin-bottom: 0px;
    margin-top: 4px;
`;

export const ContactMeSubtitle = styled.p`
    font-size: 16px;
    margin-top: 8px;
`;

export const Close = styled.div`
    display: flex;
    justify-content: end;
    padding: 8px;
`;

export const CloseButton = styled.button`
    display: flex;
    float: right;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    cursor: pointer;
`;

export const CloseIcon = styled(IoClose)`
    color: #5e5e5e;
    width: 31px;
    height: 31px;
    cursor: pointer;
    margin-right: -32px;
`;

export const ModalInputContainer = styled.div`
    margin-top: 32px;
    margin-bottom: 24px;
`;

export const ModalInput = styled.input`
    padding: 20px 16px;
    border-radius: 8px;
    display: block;
    margin-top: 8px;
    width: 100%;
    border: 1px solid var(--color-grey-100);
    background-color: #fff;
    margin-top: 10px;
    font-size: 16px;
    color: var(--color-coal);
    &:focus-visible {
        outline: 2px solid var(--color-coal);
    }
`;


export const ConsentRow = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 10px;
    margin-top: 14px;
`;

export const ConsentCheckbox = styled.input`
    appearance: none;
    -webkit-appearance: none;
    background: #fff;
    border: 1px solid #F3D2BE;
    border-radius: 5px;
    width: 24px !important;
    height: 24px !important;
    min-width: 24px;
    min-height: 24px;
    max-width: 24px;
    max-height: 24px;
    flex: 0 0 24px;
    display: inline-block;
    position: relative;
    vertical-align: middle;
    cursor: pointer;
    transition: box-shadow 0.2s;
    &:checked::after {
        content: "✓";
        display: block;
        position: absolute;
        left: 5px;
        color: #d76f2c;
        font-weight: 600;
    }
    &:hover {
        outline: 2px solid #D76F2C;
        outline-offset: 2px;
    }
`;

export const ConsentLabel = styled.label`
    font-size: 14px;
    text-align: left;
    color: var(--color-coal);
    line-height: 1.45;
    cursor: pointer;
`;

export const ErrorMessage = styled.p`
    color: var(--color-alert-color);
    text-align: left;
`;

export const Button = styled.a<{ active?: boolean | undefined }>`
    background-color: ${({ active }) => (!active ? "#cccccc" : "var(--color-orange)")} ;
    color:  var(--color-white);
    font-size: 18px;
    font-weight: var(--font-weight-bold);
    border-radius: 35px;
    padding: 16px 44px;
    text-decoration: none;
    display: block;
    text-align: center;
    width: 100%;
    box-sizing: border-box;
    margin-top: 16px;
    disabled: ${({ active }) => (!active ? "true" : "false")};
    pointer-events: ${({ active }) => (!active ? "none" : "auto")};
`;

export const HighlightedBox = styled.div`
   padding: 14px;
    border-radius: 16px;
    margin-top: 24px;
    background-color: var(--color-bg-soft);
    box-shadow: 0 4px 8px rgba(0, 0, 0, .122);
    margin-bottom: 32px;
`;

export const HighlightedBoxContainer = styled.p`
    display: flex;
    justify-content: space-between;
`;

export const HighlightedBoxHeadline = styled.p`
    font-weight: 600;
    text-align: left;
    font-size: 15px;
    margin-bottom: 4px !important;
`;

export const HighlightedBoxLabel = styled.p`
    margin-bottom: 4px;
    font-size: 14px;
`;

export const HighlightedBoxNumb = styled.p`
    font-weight: 600;
    margin-bottom: 4px;
     font-size: 14px;
`;

export const HighlightedBoxLeft = styled.div`
    text-align: left;
    color: var(--color-gray-500);
`;

export const HightlightedBoxRight = styled.div`
    text-align: right; 
    color: var(--color-coal);
`;

export const Hr = styled.hr`
     margin-top: 8px;
     margin-bottom: 8px;
`; 

export const ValueDef = styled.span`
   font-size: 12px;
    color: #999;
    font-weight: 500;
`;

export const SuccessContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 14px;
    border: 3px solid var(--color-green);
    border-radius: 42px;
    width: fit-content;
    margin: 0px auto 8px;
`;

export const Success = styled(CheckIcon)`
    color: var(--color-green);
    height: 42px; 
    width: 42px;
`;